import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { useAuth } from "./../../../../../../auth/auth";
import { getProfile } from "./../../../../../../hakakses/hakakses";
import {getUserInfoFromToken} from './../../../../../../mymixin/mymixin';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;
  const { authTokens } = useAuth();

  const classes = useStyles();

  const userInfo = getUserInfoFromToken(authTokens);
  const {name} = userInfo;
  const profileInfo = getProfile(name);

  const user = {
    name: profileInfo.nickName,
    avatar: `/images/avatars/${profileInfo.avatar}`,
    bio: profileInfo.position
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
